import { render, staticRenderFns } from "./ChatMessageConfirmation.vue?vue&type=template&id=754ba646&scoped=true&"
import script from "./ChatMessageConfirmation.vue?vue&type=script&lang=js&"
export * from "./ChatMessageConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./ChatMessageConfirmation.vue?vue&type=style&index=0&id=754ba646&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754ba646",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
